export default __webpack_public_path__ + "static/topBanner_2-7682d48fc24eeeaac81b7f60fb85a200.png";